import React from "react";

const GenericLogo = ({
  width = 56,
  height = 56,
  className = "",
  dark = false,
}) => {
  const primary = dark ? "#FFFFFF" : "#F26522";
  const secondary = dark ? "#C7D2FE" : "#0D2C54";
  const accent = dark ? "#94A3B8" : "#CBD5E1";

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
    >
      {/* Anillo exterior */}
      <circle cx="50" cy="50" r="44" stroke={primary} strokeWidth="4" />

      {/* Ondas de comunicación */}
      <circle
        cx="50"
        cy="50"
        r="34"
        stroke={accent}
        strokeWidth="2"
        strokeDasharray="6 6"
      />
      <circle
        cx="50"
        cy="50"
        r="26"
        stroke={accent}
        strokeWidth="2"
        opacity="0.6"
      />

      {/* Edificio */}
      <g>
        {/* Base */}
        <rect x="34" y="40" width="32" height="30" rx="3" fill={secondary} />

        {/* Ventanas */}
        {[38, 47, 56].map((x) => (
          <>
            <rect
              x={x}
              y="45"
              width="5"
              height="5"
              rx="1"
              fill={dark ? "#0F172A" : "#FFFFFF"}
            />
            <rect
              x={x}
              y="53"
              width="5"
              height="5"
              rx="1"
              fill={dark ? "#0F172A" : "#FFFFFF"}
            />
          </>
        ))}

        {/* Puerta */}
        <rect
          x="47"
          y="58"
          width="6"
          height="12"
          rx="1"
          fill={dark ? "#0F172A" : "#FFFFFF"}
        />

        {/* Antena citofonía */}
        <rect x="49" y="30" width="2" height="10" fill={secondary} />
        <circle cx="50" cy="28" r="3" fill={primary} />
      </g>
    </svg>
  );
};

export default GenericLogo;
